export const setMetaDescription = (desc: string) => {
  const metaDesc = document.querySelector('meta[name="description"]')
  metaDesc?.setAttribute('content', desc)
}

export const setTitle = (title: string) => {
  document.title = title
}
